import styles from "./EmployeePortfolioField.module.scss";
import { useEmployeePortfolio } from "./hooks/useEmployeePortfolio";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { showCustomConfirmDialog } from "../../../dialogs/AppConfirmDialog";

interface IEmployeePortfolioEmployeeCardProps {
  serviceTypeId?: number;
  employeeId: number;
  employeeName: string;
}

export const EmployeePortfolioEmployeeCard = ({
  serviceTypeId,
  employeeId,
  employeeName,
}: IEmployeePortfolioEmployeeCardProps) => {
  const {
    images,
    isLoading,
    isUploading,
    fileInputRef,
    handleFileChange,
    removeImage,
    canUploadMore,
  } = useEmployeePortfolio(serviceTypeId, employeeId);

  const handleAddClick = () => {
    fileInputRef.current?.click();
  };

  const handleDeleteClick = (imageId: number) => {
    showCustomConfirmDialog(
      "Сигурни ли сте, че искате да изтриете тази снимка?",
      () => removeImage(imageId)
    );
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.avatar}>
          {employeeName.charAt(0).toUpperCase()}
        </div>
        <div className={styles.name}>{employeeName}</div>
        <div className={styles.count}>{images.length} снимки</div>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        multiple
        className={styles.hiddenInput}
        onChange={handleFileChange}
      />

      <div className={styles.grid}>
        {images.map((image) => (
          <div key={image.id} className={styles.thumbWrapper}>
            <img
              src={image.url}
              alt="Портфолио"
              className={styles.thumb}
              loading="lazy"
            />
            <button
              type="button"
              className={styles.deleteButton}
              onClick={() => handleDeleteClick(image.id)}
              aria-label="Изтрий снимката"
            >
              ✕
            </button>
          </div>
        ))}

        <RenderWhen condition={canUploadMore}>
          <button
            type="button"
            className={styles.addTile}
            onClick={handleAddClick}
            disabled={isUploading}
          >
            <RenderWhen condition={isUploading}>
              <span className={styles.spinner} />
            </RenderWhen>
            <RenderWhen condition={!isUploading}>
              <>
                <span className={styles.addIcon}>+</span>
                <span className={styles.addLabel}>Качи снимка</span>
              </>
            </RenderWhen>
          </button>
        </RenderWhen>
      </div>

      <RenderWhen condition={isLoading && images.length === 0}>
        <div className={styles.loading}>Зареждане...</div>
      </RenderWhen>

      <RenderWhen condition={!canUploadMore}>
        <div className={styles.limitHint}>
          Достигнат е максималният брой снимки за този служител.
        </div>
      </RenderWhen>
    </div>
  );
};
